import React from 'react';

// Horizontal token budget meter. Fill color shifts with usage severity.
function TokenUsageMeter({ used, budget }) {
  const ratio = budget > 0 ? Math.min(used / budget, 1) : 0;
  const percent = Math.round(ratio * 100);

  const colorKey = ratio > 0.9 ? 'failed' : ratio >= 0.7 ? 'queued' : 'running';

  return (
    <div className="token-meter">
      <div className="token-meter-heading">
        <span>Token usage</span>
        <strong>
          {used.toLocaleString()} / {budget.toLocaleString()}
        </strong>
      </div>
      <div
        aria-label={`Token usage ${percent}% of budget`}
        aria-valuemax={100}
        aria-valuemin={0}
        aria-valuenow={percent}
        className="token-meter-track"
        role="progressbar"
      >
        <span className={`token-meter-fill meter-${colorKey}`} style={{ width: `${percent}%` }} />
      </div>
      <span className={`token-meter-caption caption-${colorKey}`}>{percent}% of daily budget</span>
    </div>
  );
}

export default TokenUsageMeter;
